export const BRACELET_ANSWERS = [
  {
    "image": "bracelet_statement_cuff",
    "prompt": "Statement Cuffs",
    "surveyFields": {"braceletStatementCuff": true}
  },
  {
    "image": "bracelet_natural_stone",
    "prompt": "Natural Stone",
    "surveyFields": {"braceletNaturalStone": true}
  },
  {
    "image": "bracelet_slider",
    "prompt": "Sliders",
    "surveyFields": {"braceletSlider": true}
  },
  {
    "image": "bracelet_delicate_cuff",
    "prompt": "Delicate Cuffs",
    "surveyFields": {"braceletDelicateCuff": true}
  }
];

export const EARRINGS_ANSWERS = [
  {
    "image": "wears_studs",
    "prompt": "Studs",
    "surveyFields": {"wearsStuds": true}
  },
  {
    "image": "wears_hoops",
    "prompt": "Hoops",
    "surveyFields": {"wearsHoops": true}
  },
  {
    "image": "wears_drops",
    "prompt": "Drops",
    "surveyFields": {"wearsDrops": true}
  },
  {
    "image": "wears_huggies",
    "prompt": "Huggies",
    "surveyFields": {"wearsHuggies": true}
  },
  {
    "image": "wears_climbers",
    "prompt": "Climbers",
    "surveyFields": {"wearsClimbers": true}
  },
  {
    "image": "wears_jackets",
    "prompt": "Jackets",
    "surveyFields": {"wearsJackets": true}
  },
  {
    "image": "wears_statement",
    "prompt": "Statement",
    "surveyFields": {"wearsStatement": true}
  },
  {
    "image": "wears_natural_stone",
    "prompt": "Natural Stone",
    "surveyFields": {"wearsNaturalStone": true}
  }
];

export const NECKLACE_ANSWERS = [
  {
    "image": "necklace_statement",
    "prompt": "Statement",
    "surveyFields": {"necklaceStatement": true}
  },
  {
    "image": "necklace_short_pendant",
    "prompt": "Short Pendants",
    "surveyFields": {"necklaceShortPendant": true}
  },
  {
    "image": "necklace_long_pendant",
    "prompt": "Long Pendants",
    "surveyFields": {"necklaceLongPendant": true}
  },
  {
    "image": "necklace_delicate",
    "prompt": "Delicate",
    "surveyFields": {"necklaceDelicate": true}
  },
  {
    "image": "necklace_choker",
    "prompt": "Chokers",
    "surveyFields": {"necklaceChoker": true}
  },
  {
    "image": "necklace_charm",
    "prompt": "Charms",
    "surveyFields": {"necklaceCharm": true}
  },
  {
    "image": "necklace_layered",
    "prompt": "Layered",
    "surveyFields": {"necklaceLayered": true}
  },
  {
    "image": "necklace_natural_stone",
    "prompt": "Natural Stone",
    "surveyFields": {"necklaceNaturalStone": true}
  }
];

export const RINGS_ANSWERS = [
  {
    "image": "ring_statement",
    "prompt": "Statement",
    "surveyFields": {"ringStatement": true}
  },
  {
    "image": "ring_delicate",
    "prompt": "Delicate",
    "surveyFields": {"ringDelicate": true}
  },
  {
    "image": "ring_set",
    "prompt": "Sets",
    "surveyFields": {"ringSet": true}
  },
  {
    "image": "ring_natural_stone",
    "prompt": "Natural Stone",
    "surveyFields": {"ringNaturalStone": true}
  }
];

export const TREND_ANSWERS = [
  {
    "image": "trend-statement",
    "prompt": "Statement Earrings",
    "surveyFields": {"trendStatementEarrings": true}
  },
  {
    "image": "trend-hoops",
    "prompt": "Hoops + Huggies",
    "surveyFields": {"trendHoops": true}
  },
  {
    "image": "trend-ear-party",
    "prompt": "Ear Party",
    "surveyFields": {"trendEarParty": true}
  },
  {
    "image": "trend-bracelet-stacks",
    "prompt": "Bracelet Stacks",
    "surveyFields": {"trendBraceletStacks": true}
  },
  {
    "image": "trend-demi-fine",
    "prompt": "Demi-Fine",
    "surveyFields": {"trendDemiFine": true}
  },
  {
    "image": "trend-spiritual",
    "prompt": "Celestial + Spiritual",
    "surveyFields": {"trendSpiritualSymbols": true}
  },
  {
    "image": "trend-layering",
    "prompt": "Layering",
    "surveyFields": {"trendLayering": true}
  },
  {
    "image": "trend-ring-stacks",
    "prompt": "Ring Stacks",
    "surveyFields": {"trendRingStacks": true}
  }
];
